import * as CustomerRoutes from './customer.routes';
import { IControllerConstructor } from 'angular';
import { CustomerDetailsService } from '../../services/customer-detail/customer-detail.service';
import { CustomerCreateController } from './create/customers_create.controller';
import { CustomerDetailController } from './detail/customer-detail.controller';
import { CustomerEditController } from './edit/customer-edit.controller';
import { CustomerEntitlementsController } from './entitlements/customer-entitlements.controller';
import { CustomerListController } from './list/customers-list.controller';
import { CustomerPageController } from './page/customer-page.controller';
import { CustomerPursesController } from './purses/customer-purses.controller';
import { CustomerSmartMediaListController } from './smart-media/customer-smart-media-list.controller';
import { SmartMediaAddCardController } from './smart-media/add-card/smart-media-add-card.controller';
import { CustomerTicketsController } from './tickets/customer-tickets.controller';
import { CustomerChargeAccountController } from './charge-account/customer-charge-account.controller';
import { ChargeAccountListController } from './charge-account/charge-account-list.controller';
import { PaymentDetailController } from './payments/detail/payment-detail.controller';
import { PaymentListController } from './payments/list/payment-list.controller';
import { PanelMenuController } from './payments/list/panel-menu.controller';
import { TicketHistoryController } from './payments/ticket/ticket-history.controller';
import { TicketValidity } from './tickets/ticket-validity.filter';
import { TicketDetailsController } from './ticket-details/ticket-details.controller';


export const initialise = function () {

  /**
   * Customers Module
   */
  angular.module('actora.customers', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    'ui.router'
  ])
    .factory('customerDetailService', ['$translate', 'LinkBuilder', ($translate, LinkBuilder) => {
      return new CustomerDetailsService($translate, LinkBuilder);
    }])
    .controller('CustomersCreateController', <IControllerConstructor>CustomerCreateController)
    .controller('CustomerDetailController', <IControllerConstructor>CustomerDetailController)
    .controller('CustomerEditController', <IControllerConstructor>CustomerEditController)
    .controller('CustomerEntitlementsController', <IControllerConstructor>CustomerEntitlementsController)
    .controller('CustomersListController', <IControllerConstructor>CustomerListController)
    .controller('CustomerPageController', <IControllerConstructor>CustomerPageController)
    .controller('CustomerPursesController', <IControllerConstructor>CustomerPursesController)
    .controller('CustomerSmartMediaListController', <IControllerConstructor>CustomerSmartMediaListController)
    .controller('SmartMediaAddCardController', <IControllerConstructor>SmartMediaAddCardController)
    .controller('CustomerTicketsController', <IControllerConstructor>CustomerTicketsController)
    .controller('CustomerChargeAccountController', <IControllerConstructor>CustomerChargeAccountController)
    .controller('ChargeAccountListController', <IControllerConstructor>ChargeAccountListController)
    .controller('PaymentDetailController', <IControllerConstructor>PaymentDetailController)
    .controller('PaymentListController', <IControllerConstructor>PaymentListController)
    .controller('PanelMenuController', <IControllerConstructor>PanelMenuController)
    .controller('TicketHistoryController', <IControllerConstructor>TicketHistoryController)
    .controller('TicketDetailsController', <IControllerConstructor>TicketDetailsController)
    .constant('paymentConstants', {
      PAYMENT_STATUS: {
        SUCCESSFUL: 'PAYMENT_STATUS.SUCCESSFUL',
        ACTIVE: 'PAYMENT_STATUS.ACTIVE',
        PROCESSING: 'PAYMENT_STATUS.PROCESSING',
        FAILED: 'PAYMENT_STATUS.FAILED',
        CANCELLED: 'PAYMENT_STATUS.CANCELLED',
        VOIDED: 'PAYMENT_STATUS.VOIDED',
        EXPIRED: 'PAYMENT_STATUS.EXPIRED'
      }
    })
    .constant('customerConstants', {
      CUSTOMER_STATUS: [
        { id: 'AWAITING_ISSUE', value: 'STATUSES.AWAITING_ISSUE' },
        { id: 'AWAITING_INFORMATION', value: 'STATUSES.AWAITING_INFORMATION' },
        { id: 'DECEASED', value: 'STATUSES.DECEASED' },
        { id: 'DUPLICATE', value: 'STATUSES.DUPLICATE' },
        { id: 'DELETED', value: 'STATUSES.DELETED' },
        { id: 'INVALID', value: 'STATUSES.INVALID' },
        { id: 'LOCKED', value: 'STATUSES.LOCKED' },
        { id: 'MOVED_AWAY', value: 'STATUSES.MOVED_AWAY' },
        { id: 'NOT_QUALIFYING', value: 'STATUSES.NOT_QUALIFYING' },
        { id: 'PENDING_VALIDATION', value: 'STATUSES.PENDING_VALIDATION' },
        { id: 'POTENTIAL_DUPLICATE', value: 'STATUSES.POTENTIAL_DUPLICATE' },
        { id: 'REJECTED', value: 'STATUSES.REJECTED' },
        { id: 'VALID', value: 'STATUSES.VALID' }
      ],
      SALUTATIONS: [
        { id: 'MR', value: 'CUSTOMER_DETAIL.MR' },
        { id: 'MRS', value: 'CUSTOMER_DETAIL.MRS' },
        { id: 'MISS', value: 'CUSTOMER_DETAIL.MISS' }
      ],
      ADDRESS_TYPES: [
        { id: 'HOME', value: 'HOME' },
        { id: 'WORK', value: 'WORK' },
        { id: 'SCHOOL', value: 'SCHOOL' },
        { id: 'OTHER', value: 'OTHER' }
      ],
      CONTACT_TYPES: [
        { id: 'HOME', value: 'HOME' },
        { id: 'MOBILE', value: 'MOBILE' },
        { id: 'EMAIL', value: 'EMAIL' }
      ],
      PAYMENT_TYPES: {
        AUTOMATIC: 'autorenew',
        SINGLE: 'touch_app',
        RECURRING: 'history'
      },
      IMAGES: {
        ITSO: 'itso',
        CEMV: 'cemv',
        DESFIRE: 'desfire',
        CONTACTLESS_MICROPROCESSOR: 'cemv',
        MIFARE_1K: 'mifare_1k',
        MIFARE_4K: 'mifare_4k',
        MICROPROCESSOR: 'microprocessor'
      },
      REGEX_LIST: {
        HOME: {
          pattern: '\\d+',
          length: '11'
        },
        MOBILE: {
          pattern: '\\d+',
          length: '11'
        },
        EMAIL: {
          pattern: '[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$',
          length: '254'
        },
        POSTCODE: {
          pattern: '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?( |)[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}'
        }
      },
      TOKEN_TYPES: {
        VISA_CREDIT: 'CUSTOMER_DETAIL.PAYMENT_TYPES.VISA',
        VISA_DEBIT: 'CUSTOMER_DETAIL.PAYMENT_TYPES.VISA_DEBIT',
        MASTERCARD: 'CUSTOMER_DETAIL.PAYMENT_TYPES.MASTERCARD',
        MAESTRO: 'CUSTOMER_DETAIL.PAYMENT_TYPES.MAESTRO',
        AMEX: 'CUSTOMER_DETAIL.PAYMENT_TYPES.AMEX',
        JCB: 'CUSTOMER_DETAIL.PAYMENT_TYPES.JCB',
        DISCOVER: 'CUSTOMER_DETAIL.PAYMENT_TYPES.DISCOVER'
      }
    })
    .filter('ticketValidity', () => { return TicketValidity.onFilterApplied; });

  CustomerRoutes.initialise();
};
